"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI_Z_TOP = exports.UI_Z_5 = exports.UI_Z_4 = exports.UI_Z_3 = exports.UI_Z_2 = exports.UI_Z_1 = void 0;

/**
 * Do not edit directly
 * Generated on Wed, 31 Jan 2024 01:00:33 GMT
 */
var UI_Z_1 = 1;
exports.UI_Z_1 = UI_Z_1;
var UI_Z_2 = 2;
exports.UI_Z_2 = UI_Z_2;
var UI_Z_3 = 3;
exports.UI_Z_3 = UI_Z_3;
var UI_Z_4 = 4;
exports.UI_Z_4 = UI_Z_4;
var UI_Z_5 = 5;
exports.UI_Z_5 = UI_Z_5;
var UI_Z_TOP = 9999;
exports.UI_Z_TOP = UI_Z_TOP;